'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pool = exports.multisig = exports.contractSuperSpeedJsons = undefined;

var _Head = require('./contracts/Head.json');

var _Head2 = _interopRequireDefault(_Head);

var _Context = require('./contracts/Context.json');

var _Context2 = _interopRequireDefault(_Context);

var _Catalogue = require('./contracts/Catalogue.json');

var _Catalogue2 = _interopRequireDefault(_Catalogue);

var _StorageCatalogue = require('./contracts/StorageCatalogue.json');

var _StorageCatalogue2 = _interopRequireDefault(_StorageCatalogue);

var _ValidatorSet = require('./contracts/ValidatorSet.json');

var _ValidatorSet2 = _interopRequireDefault(_ValidatorSet);

var _BlockRewards = require('./contracts/BlockRewards.json');

var _BlockRewards2 = _interopRequireDefault(_BlockRewards);

var _AtlasStakeStore = require('./contracts/AtlasStakeStore.json');

var _AtlasStakeStore2 = _interopRequireDefault(_AtlasStakeStore);

var _BundleStore = require('./contracts/BundleStore.json');

var _BundleStore2 = _interopRequireDefault(_BundleStore);

var _Roles = require('./contracts/Roles.json');

var _Roles2 = _interopRequireDefault(_Roles);

var _KycWhitelist = require('./contracts/KycWhitelist.json');

var _KycWhitelist2 = _interopRequireDefault(_KycWhitelist);

var _KycWhitelistStore = require('./contracts/KycWhitelistStore.json');

var _KycWhitelistStore2 = _interopRequireDefault(_KycWhitelistStore);

var _Fees = require('./contracts/Fees.json');

var _Fees2 = _interopRequireDefault(_Fees);

var _Challenges = require('./contracts/Challenges.json');

var _Challenges2 = _interopRequireDefault(_Challenges);

var _ChallengesStore = require('./contracts/ChallengesStore.json');

var _ChallengesStore2 = _interopRequireDefault(_ChallengesStore);

var _Sheltering = require('./contracts/Sheltering.json');

var _Sheltering2 = _interopRequireDefault(_Sheltering);

var _PayoutsStore = require('./contracts/PayoutsStore.json');

var _PayoutsStore2 = _interopRequireDefault(_PayoutsStore);

var _RolesStore = require('./contracts/RolesStore.json');

var _RolesStore2 = _interopRequireDefault(_RolesStore);

var _Payouts = require('./contracts/Payouts.json');

var _Payouts2 = _interopRequireDefault(_Payouts);

var _ShelteringTransfers = require('./contracts/ShelteringTransfers.json');

var _ShelteringTransfers2 = _interopRequireDefault(_ShelteringTransfers);

var _ShelteringTransfersStore = require('./contracts/ShelteringTransfersStore.json');

var _ShelteringTransfersStore2 = _interopRequireDefault(_ShelteringTransfersStore);

var _Time = require('./contracts/Time.json');

var _Time2 = _interopRequireDefault(_Time);

var _Config = require('./contracts/Config.json');

var _Config2 = _interopRequireDefault(_Config);

var _Uploads = require('./contracts/Uploads.json');

var _Uploads2 = _interopRequireDefault(_Uploads);

var _ApolloDepositStore = require('./contracts/ApolloDepositStore.json');

var _ApolloDepositStore2 = _interopRequireDefault(_ApolloDepositStore);

var _ValidatorProxy = require('./contracts/ValidatorProxy.json');

var _ValidatorProxy2 = _interopRequireDefault(_ValidatorProxy);

var _SuperSpeedConfig = require('./contracts/SuperSpeedConfig.json');

var _SuperSpeedConfig2 = _interopRequireDefault(_SuperSpeedConfig);

var _SuperSpeedTime = require('./contracts/SuperSpeedTime.json');

var _SuperSpeedTime2 = _interopRequireDefault(_SuperSpeedTime);

var _ChallengesEventEmitter = require('./contracts/ChallengesEventEmitter.json');

var _ChallengesEventEmitter2 = _interopRequireDefault(_ChallengesEventEmitter);

var _RolesEventEmitter = require('./contracts/RolesEventEmitter.json');

var _RolesEventEmitter2 = _interopRequireDefault(_RolesEventEmitter);

var _TransfersEventEmitter = require('./contracts/TransfersEventEmitter.json');

var _TransfersEventEmitter2 = _interopRequireDefault(_TransfersEventEmitter);

var _Multiplexer = require('./contracts/Multiplexer.json');

var _Multiplexer2 = _interopRequireDefault(_Multiplexer);

var _MultiSigWallet = require('./contracts/MultiSigWallet.json');

var _MultiSigWallet2 = _interopRequireDefault(_MultiSigWallet);

var _RewardsEventEmitter = require('./contracts/RewardsEventEmitter.json');

var _RewardsEventEmitter2 = _interopRequireDefault(_RewardsEventEmitter);

var _PoolsNodesManager = require('./contracts/PoolsNodesManager.json');

var _PoolsNodesManager2 = _interopRequireDefault(_PoolsNodesManager);

var _PoolsStore = require('./contracts/PoolsStore.json');

var _PoolsStore2 = _interopRequireDefault(_PoolsStore);

var _Pool = require('./contracts/Pool.json');

var _Pool2 = _interopRequireDefault(_Pool);

var _PoolEventsEmitter = require('./contracts/PoolEventsEmitter.json');

var _PoolEventsEmitter2 = _interopRequireDefault(_PoolEventsEmitter);

var _NodeAddressesStore = require('./contracts/NodeAddressesStore.json');

var _NodeAddressesStore2 = _interopRequireDefault(_NodeAddressesStore);

var _RolesPrivilagesStore = require('./contracts/RolesPrivilagesStore.json');

var _RolesPrivilagesStore2 = _interopRequireDefault(_RolesPrivilagesStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contractJsons = {
  head: _Head2.default,
  context: _Context2.default,
  catalogue: _Catalogue2.default,
  storageCatalogue: _StorageCatalogue2.default,
  validatorSet: _ValidatorSet2.default,
  blockRewards: _BlockRewards2.default,
  time: _Time2.default,
  atlasStakeStore: _AtlasStakeStore2.default,
  roles: _Roles2.default,
  bundleStore: _BundleStore2.default,
  kycWhitelist: _KycWhitelist2.default,
  kycWhitelistStore: _KycWhitelistStore2.default,
  sheltering: _Sheltering2.default,
  fees: _Fees2.default,
  challenges: _Challenges2.default,
  challengesStore: _ChallengesStore2.default,
  payoutsStore: _PayoutsStore2.default,
  payouts: _Payouts2.default,
  shelteringTransfers: _ShelteringTransfers2.default,
  shelteringTransfersStore: _ShelteringTransfersStore2.default,
  config: _Config2.default,
  uploads: _Uploads2.default,
  rolesStore: _RolesStore2.default,
  apolloDepositStore: _ApolloDepositStore2.default,
  validatorProxy: _ValidatorProxy2.default,
  challengesEventEmitter: _ChallengesEventEmitter2.default,
  rolesEventEmitter: _RolesEventEmitter2.default,
  transfersEventEmitter: _TransfersEventEmitter2.default,
  rewardsEventEmitter: _RewardsEventEmitter2.default,
  poolsNodesManager: _PoolsNodesManager2.default,
  nodeAddressesStore: _NodeAddressesStore2.default,
  poolsStore: _PoolsStore2.default,
  poolEventsEmitter: _PoolEventsEmitter2.default,
  multiplexer: _Multiplexer2.default,
  rolesPrivilagesStore: _RolesPrivilagesStore2.default
}; /*
   Copyright: Ambrosus Inc.
   Email: tech@ambrosus.io
   
   This Source Code Form is subject to the terms of the Mozilla Public License, v. 2.0. If a copy of the MPL was not distributed with this file, You can obtain one at https://mozilla.org/MPL/2.0/.
   
   This Source Code Form is “Incompatible With Secondary Licenses”, as defined by the Mozilla Public License, v. 2.0.
   */

var contractSuperSpeedJsons = exports.contractSuperSpeedJsons = {
  config: _SuperSpeedConfig2.default,
  time: _SuperSpeedTime2.default
};

var multisig = exports.multisig = _MultiSigWallet2.default;
var pool = exports.pool = _Pool2.default;

exports.default = contractJsons;